import { render } from "./GamePlay.vue?vue&type=template&id=fc58d418"
import script from "./GamePlay.vue?vue&type=script&lang=js"
export * from "./GamePlay.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__